import {
  REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID,
  RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID,
  REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID,
  failure: REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR,
  receive: RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID
})

export default function (state = {}, { type, payload = {} }) {
  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state
  const { chargeId } = payload
  switch (type) {
    case REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID:
    case REQUEST_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID_ERROR:
    case RECEIVE_BILLING_CHARGE_BY_WORKSPACE_SLUG_AND_CHARGE_ID:
      return {
        ...state,
        [chargeId]: reducer(state[chargeId], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/receipt.js